import { FieldValues, Path } from "react-hook-form";
import { useDependantControlsTrigger } from "../hooks";

interface DependantTriggerProps<TFieldValues extends FieldValues> {
  value: any;
  controls: Path<TFieldValues>[];
}

export default function DependantTrigger<TFieldValues extends FieldValues>(
  props: Readonly<DependantTriggerProps<TFieldValues>>,
) {
  const { value, controls } = props;
  useDependantControlsTrigger(value, controls);
  return null;
}
